import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../../../auth/store/actions';
import { API } from "../../../config";
import { saveAs } from 'file-saver';
import {Button} from "@material-ui/core";

const ExcelJS = require('exceljs');

const CompletedTrades = API.service('completed-trades');
const Brokers = API.service('authorized-brokers');
const Companies = API.service('company');
const certificates = API.service('certificates');

const moment = require('moment');

const styles = theme => ({
    layoutRoot: {},

    textLink: {
        margin:0,
        padding:0,
        lineHeight: 1,
        minHeight:'16px',
        textTransform: 'none',
        color:"#039be5",

        "&:hover":{
            background:'transparent',
            textDecoration:'underline'
        }
    }
});

class Custodian extends Component {
    state = {
        trades:false,
        brokers:false,
        companies:false,
        days:false,
        headers:[
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
        ]
    };

    test = (data, filename) => {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'DCSX';
        workbook.lastModifiedBy = 'DCSX';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();

        workbook.calcProperties.fullCalcOnLoad = true;

        workbook.views = [
            {
                x: 0, y: 0, width: 10000, height: 20000,
                firstSheet: 0, activeTab: 1, visibility: 'visible'
            }
        ]

        const worksheet = workbook.addWorksheet('My Sheet');

        worksheet.columns = [
            { header: 'Instrument', key: 'Instrument', width: 15 },
            { header: 'Broker', key: 'Broker', width: 15 },
            { header: 'Investor', key: 'Investor', width: 20 },
            { header: 'Movement', key: 'Movement', width: 10 },
            { header: 'Custodial Identifier', key: 'Custodial Identifier', width: 20 },
            { header: 'Safekeeping Identifier', key: 'Safekeeping Identifier', width: 20 }
        ];

        worksheet.addRows(data);

        workbook.xlsx.writeBuffer().then(function (data) {
            var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            saveAs(blob,filename);
        });

        return false;
    }

    componentDidMount() {
        const app = this;

        Brokers.find({query:{$limit:10000}}).then(brokers=>{
            var b = {};
            brokers.data.forEach(broker=>{
                b[broker._id] = broker;
            })

            app.setState({
                brokers:b
            })

            Companies.find({query:{$limit:10000}}).then(companies=>{
                var c = {};
                companies.data.forEach(company=>{
                    c[company._company_account] = company;
                })

                app.setState({
                    companies:c
                })

                CompletedTrades.find({query:{$limit:100000,$sort:{'_ts_executed':-1}}}).then(t=>{
                    var x = {};
                    var days = {};

                    let custodial_identifiers = {}

                    certificates.find({query:{type:'group',$limit:1000}}).then(certs=>{
                        certs.forEach(cert => {
                            console.log(cert);

                            if (typeof custodial_identifiers[cert._account] === 'undefined'){
                                custodial_identifiers[cert._account] = {};
                            }

                            custodial_identifiers[cert._account][cert.broker_id] = {
                                custodial_identifier: cert.custodial_identifier,
                                custodial_safekeeping_account: cert.custodial_safekeeping_account
                            }
                        });

                        console.log(custodial_identifiers);

                        t.data.forEach(c => {
                            var d = moment(c.createdAt).format('YYYY-MM-DD');
                            if(typeof x[d] === 'undefined'){
                                x[d] = 0;
                                days[d] = [];
                            }

                            let instrument = this.state.companies[c._company_account]._company_symbol,
                                seller = c._selling_investor_account,
                                buyer  = c._buying_investor_account

                            if(typeof days[d][instrument] === 'undefined'){
                                days[d][instrument] = {}
                            }


                            console.log(c, custodial_identifiers[c._company_account][c._buying_broker_id]);
                            if(typeof days[d][instrument][buyer] === 'undefined'){
                                days[d][instrument][buyer] = {
                                    quantity:0,
                                    broker: b[c._buying_broker_id]._name,
                                    custodial_identifier: (typeof custodial_identifiers[c._company_account] !== 'undefined' && typeof custodial_identifiers[c._company_account][c._buying_broker_id] !== 'undefined') ? custodial_identifiers[c._company_account][c._buying_broker_id].custodial_identifier : '',
                                    safekeeping: (typeof custodial_identifiers[c._company_account] !== 'undefined' && typeof custodial_identifiers[c._company_account][c._buying_broker_id] !== 'undefined') ? custodial_identifiers[c._company_account][c._buying_broker_id].custodial_safekeeping_account :''
                                }
                            }

                            if(typeof days[d][instrument][seller] === 'undefined'){
                                days[d][instrument][seller] = {
                                    quantity:0,
                                    broker: b[c._selling_broker_id]._name,
                                    custodial_identifier: (typeof custodial_identifiers[c._company_account] !== 'undefined' && typeof custodial_identifiers[c._company_account][c._selling_broker_id] !== 'undefined') ? custodial_identifiers[c._company_account][c._selling_broker_id].custodial_identifier : '',
                                    safekeeping: (typeof custodial_identifiers[c._company_account] !== 'undefined' && typeof custodial_identifiers[c._company_account][c._selling_broker_id] !== 'undefined') ? custodial_identifiers[c._company_account][c._selling_broker_id].custodial_safekeeping_account : ''
                                }
                            }

                            days[d][instrument][seller].quantity -= c._quantity;
                            days[d][instrument][buyer].quantity += c._quantity;

                            x[d] += 1;
                        });

                        var new_days = {};

                        console.log(days);

                        Object.keys(days).forEach(d=>{
                            if(typeof new_days[d] === 'undefined'){
                                new_days[d] = [];
                            }
                            Object.keys(days[d]).forEach (c=>{
                                console.log(c)
                                Object.keys(days[d][c]).forEach (i=>{

                                    let x = { "Instrument":c , "Broker":days[d][c][i].broker, "Investor":i.toString(), "Movement":days[d][c][i].quantity, "Custodial Identifier": days[d][c][i].custodial_identifier, "Safekeeping Identifier": days[d][c][i].safekeeping};
                                    new_days[d].push(x)
                                })
                            })
                        })

                        app.setState({
                            trades:x,
                            days:new_days
                        })
                    });
                })
            })
        })
    }

    render()
    {
        const {classes} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Custodial Movement</h4></div>
                }
                content={
                    <div className="p-24">
                        <table>
                            <thead>
                            <tr>
                                <td width="130px" style={{fontWeight:'bold'}}>Date</td>
                                <td width="130px" style={{fontWeight:'bold'}}>Trades</td>
                                <td width="330px" style={{fontWeight:'bold'}}>Action</td>
                            </tr>
                            </thead>
                            {(this.state.trades) &&
                                <tbody>
                                    {Object.keys(this.state.trades).map((d)=>{
                                        return (
                                          <tr>
                                              <td>{d}</td>
                                              <td>{this.state.trades[d]}</td>
                                              <td><Button className={classes.textLink} size={"small"} onClick={() => this.test(this.state.days[d],"custodian_"+d+".xlsx")}>Download XLSX</Button></td>
                                          </tr>
                                        )
                                    })}
                                </tbody>
                            }
                        </table>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        setUserData: Actions.setUserData,
        setUserDataFromDB: Actions.setUserDataFromDB,
    }, dispatch);
}

function mapStateToProps({fuse, auth})
{
    return {
        login   : auth.login,
        user    : auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps,mapDispatchToProps)(Custodian));



// WEBPACK FOOTER //
// ./src/main/content/custodian/Custodian.js